module.exports = (__webpack_require__(7))(871);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/style-loader/addStyles.js from dll-reference vendor
// module id = 617
// module chunks = 2